import Icon from 'veui/components/Icon'
import { IconSignOut } from 'dls-icons-vue'

Icon.register('sign-out', IconSignOut)
